import { render, staticRenderFns } from "./LMSDashboardLink.vue?vue&type=template&id=2df87dad&scoped=true"
import script from "./LMSDashboardLink.vue?vue&type=script&lang=ts"
export * from "./LMSDashboardLink.vue?vue&type=script&lang=ts"
import style0 from "./LMSDashboardLink.vue?vue&type=style&index=0&id=2df87dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df87dad",
  null
  
)

export default component.exports